import axios from "axios";
import { store } from "../store/store";

const apiUrl = process.env.REACT_APP_API_URL || "http://192.168.1.22:8010/Service/V2";

const specialApiUrls = [
  "/kiosk/ajaxSearchReservation.do",
  "/kiosk/saveApprovalInfo.do",
  "/kiosk/saveApprovalInfo.do",
  "/kiosk/saveAdditionCharge.do",
  "/kiosk/saveDriverInfo.do",
  "/kiosk/ajaxSaveSignatureImage.do",
  "/kiosk/sendSMS.do",
  "http://192.168.1.22:8010/Service/Mobile/V1/1/DriverLicenseValidator.do",
];

const Axios = () => {
  const axiosInstance = axios.create({
    baseURL: apiUrl,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    withCredentials: true,
    timeout: 30000, // 타임아웃 설정 (밀리초 단위)
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      console.log(config.url);
      if (specialApiUrls.some((url) => config?.url?.includes(url))) {
        store.dispatch({
          type: "LOADING",
        });
      }
      return config;
    },
    (error) => {
      store.dispatch({
        type: "LOADED",
      });
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      if (response.config.url && specialApiUrls.some((url) => response?.config?.url?.includes(url))) {
        store.dispatch({
          type: "LOADED",
        });
      }
      return response;
    },
    (error) => {
      store.dispatch({
        type: "LOADED",
      });
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default Axios;
